import styled, { css, keyframes } from 'styled-components';

const dropdown = keyframes`
  0% {
    opacity: 0;
    transform: translate(0px, -10px);
  }
  100% {
    opacity: 1;
    transform: translate(0px, 0px);
  }
`;

interface IDropdown {
  open: boolean;
  typeMenu?: string;
}

export const Container = styled.nav`
  font-family: 'Inter Regular';
  display: flex;
  align-items: center;
  min-width: 220px;

  span {
    color: #93979B;
    font-family: 'Inter Regular';
    text-decoration: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }

  .my-specialists {
    display: inline-block;
    position: relative;
    width: 100%;

    .selected {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 16px 20px;
      border: 1px solid rgba(155, 153, 175, 0.31);
      border-radius: 8px;
      background-color: #fff;
      min-height: 24px;
      box-sizing: border-box;
      
      &:hover {
        border-color: var(--primary-color);
      }
    }

    .arrow-speciality {
     color: #D82E88;
      height: 20px;
      width: 20px;
      transform: rotate(270deg);
      margin-left: 10px;
      transition: transform 0.3s ease;
      flex-shrink: 0;
      
      &.rotated {
        transform: rotate(90deg);
      }
    }
  }

  @media (max-width: 768px) {
    min-width: 100%;
    
    .my-specialists .selected {
      padding: 14px 16px;
    }
    
    span {
      font-size: 14px;
    }
  }
`;

export const Dropdown = styled.div<IDropdown>`
  ${({ open }) => css`
    display: ${open ? 'block' : 'none'};
    animation: ${dropdown} 0.3s ease-out;
  `}

  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(155, 153, 175, 0.31);
  padding: 8px 0;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;

  .triangle {
    position: absolute;
    height: 12px;
    width: 12px;
    top: -6px;
    right: 30px;
    transform: rotate(45deg);
    background-color: #fff;
    border-left: 1px solid rgba(155, 153, 175, 0.31);
    border-top: 1px solid rgba(155, 153, 175, 0.31);
    z-index: 1001;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    display: flex;
    align-items: center;
    list-style-type: none;
    color: var(--secondary-color);
    font-family: 'Inter Regular';
    font-size: 16px;
    cursor: pointer;
    padding: 12px 20px;
    border-bottom: none;
    margin: 0;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: rgba(228, 108, 154, 0.05);
    }
    
    &:last-child {
      border-bottom: none;
    }
  }

  .selected-specialty {
    color: var(--primary-color);
    background-color: rgba(228, 108, 154, 0.1);
    font-weight: 500;
  }
  
  @media (max-width: 768px) {
    li {
      font-size: 14px;
      padding: 10px 16px;
    }
  }
`;